import { Loader } from '@sdir/sds';
import React, { useMemo } from 'react';
import { useFeatureToggles } from '../../services/hooks/useFeatureToggles';
import { useCurrentPerson } from '../../services/hooks/useCurrentPerson';
import { isToggleOn } from '../../constants/permissions';

interface ToggleContentProps {
  toggleName: string;
  children: any;
  inverse?: boolean;
  showLoader?: boolean;
  alternativeChildren?: any;
}

export const ToggleContent: React.FC<ToggleContentProps> = ({
  toggleName,
  children,
  showLoader = false,
  inverse = false,
  alternativeChildren,
}) => {
  const {
    person: { loading: loadingUser, result: resultUser },
  } = useCurrentPerson();
  const { result, loading } = useFeatureToggles();

  const prereleaseFeaturesEnabled = useMemo(() => {
    const isOn = isToggleOn(result, toggleName, resultUser?.personalIdentificationNumber);
    return inverse ? !isOn : isOn;
  }, [inverse, result, resultUser, toggleName]);

  if ((loading || loadingUser) && showLoader) return <Loader />;
  return prereleaseFeaturesEnabled ? children : alternativeChildren || <div />;
};
